// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "body{height:100%;min-width:6.25rem;margin:0}#app,body{overflow:hidden}#app{font-family:SourceHanSansCN-Regular,Microsoft YaHei,Avenir,Helvetica,Arial,sans-serif;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;color:#000}", ""]);
// Exports
module.exports = exports;
